import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FancyDropdownContext from 'dpl/components/FancyDropdown/context';

/** @param {any} props */
export default function FancyDropdownMenu({
  children,
  className = null,
  contentClassName = 'ph2 pv2',
  newDesignSystemStyles = false
}) {
  return (
    <FancyDropdownContext.Consumer>
      {({ isOpen, menuRef, positionAlignment, menuWidth, maxMenuHeight }) => {
        if (!isOpen) {
          return null;
        }

        return (
          <div className="FancyDropdownMenu relative">
            <ul
              ref={menuRef}
              className={classnames(
                'w-100 z-max br1 overscroll-contain',
                {
                  absolute: positionAlignment !== 'static',
                  'right-0': positionAlignment === 'right',
                  'left-0': positionAlignment === 'left',
                  'fw-medium br12 bg-white overflow-hidden dropdown-box-shadow':
                    newDesignSystemStyles
                },
                className
              )}
              style={{ width: menuWidth }}
            >
              <div
                className={classnames(
                  'bg-white overflow-y-auto',
                  contentClassName
                )}
                style={{ maxHeight: maxMenuHeight }}
              >
                {children}
              </div>
            </ul>
          </div>
        );
      }}
    </FancyDropdownContext.Consumer>
  );
}

FancyDropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  newDesignSystemStyles: PropTypes.bool
};
